import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import s from './SignalTranslation.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { initialSignalTranslationState } from '../../reducers/initialState';
import { v4 as uuidv4 } from 'uuid';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { Navigate, Link, useParams } from 'react-router-dom';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ContentTemplate from '../ContentTemplate/ContentTemplate';
import Dropdown from '../WSAControls/DroprdownContainer/Dropdown';
import classNames from 'classnames';
import { isRequired, compareValues } from '../../utils';
import { v4 as uuid } from 'uuid' ;
import Cookies from 'js-cookie';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import DateTime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import moment from 'moment-timezone';
import SignalTranslationResults from './SignalTranslationResults';
import SignalTranslationConstants from './SignalTranslationConstants';
import SignalTranslationComments from './SignalTranslationComments';
import { SIGNALTRANSLATION_DRAFT } from '../../constants/index';
import GoBack from '../WSAControls/GoBack/GoBack';


const SignalTranslation = ({
  signalTranslationManager = {...initialSignalTranslationState.signalTranslation},
  userProfileWidgets,
  currentTimezone,
  unitComponentParts = [],
  unitSubComponentDetails = [],
  setSignalTranslationChange,
  setSignalTranslationResultChange,
  setSignalTranslationConstant,
  describeSignalTranslation,
  describeSignalTranslationEquation,
  getUnitComponentParts,
  saveSignalTranslation,
  saveSignalTranslationComment,
  selectedUnit,
  intl
}) => {
  let IsEdit = false;
  let IsRedirect = false;
  let { unitSerialNumber, unitId, signalTranslationId } = useParams();
  const [localformErrors, setFormErrors] = useState({});

  const envName = process.env.REACT_APP_ENV_NAME_SHORT;

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATION_EDIT');
  const isCommentAllowed = IsWidgetAccessible(userProfileWidgets, 'SIGNALTRANSLATION_COMMENT_ADD');

  let userName = Cookies.get(`name-${envName}`) || '';
  var d = new Date();
  const currentTimestamp = signalTranslationManager.SelectedSignalTranslation.SignalTranslationDateTime
    ? signalTranslationManager.SelectedSignalTranslation.SignalTranslationDateTime
    : moment(d).unix();

  let widgetCode = '';

  if (signalTranslationId && parseInt(signalTranslationId) > 0) {
    IsEdit = true;
    userName = signalTranslationManager.SelectedSignalTranslation.FullName;
    widgetCode = 'SIGNALTRANSLATION_EDIT';
  }

  useEffect(() => {
    if ((!signalTranslationId || signalTranslationId === 0) && unitId > 0) {
      getUnitComponentParts(unitSerialNumber, unitId);
    }
  }, [getUnitComponentParts, signalTranslationId, unitSerialNumber, unitId]);

  useEffect(() => {
    if (unitSerialNumber.length > 0 && signalTranslationId > 0) {
      describeSignalTranslation(signalTranslationId, unitSerialNumber);
    } else {
      setSignalTranslationChange({
        SelectedSignalTranslation: { ...signalTranslationManager.SelectedSignalTranslation, ...initialSignalTranslationState.signalTranslation.SelectedSignalTranslation }
      });
    }
  }, [describeSignalTranslation, signalTranslationId, unitSerialNumber]);

  const signalTranslationRequiredToggleHandler = () => {
    setSignalTranslationChange({
      SelectedSignalTranslation: {
        ...signalTranslationManager.SelectedSignalTranslation,
        SignalTranslationRequired: !signalTranslationManager.SelectedSignalTranslation.SignalTranslationRequired
      }
    });
  };

  const onSensorDropdownChange = e => {
    let unitComponentType = getUnitComponentTypeInfoById(0);
    setSignalTranslationChange({
      SelectedSignalTranslation: {
        ...signalTranslationManager.SelectedSignalTranslation,
        ...unitComponentType,
        SignalTranslationDateTime: currentTimestamp,
        ComponentPartId: e.value
      }
    });
  };

  const onDropdownChange = e => {
    let unitComponentType = getUnitComponentTypeInfoById(e.value);
    let modelCategoryId = selectedUnit && selectedUnit.ModelCategoryId || null;
    describeSignalTranslationEquation(unitComponentType.SignalTranslationEquationId, signalTranslationId, modelCategoryId);
    setSignalTranslationChange({
      SelectedSignalTranslation: { ...signalTranslationManager.SelectedSignalTranslation, ...unitComponentType, SignalTranslationDateTime: currentTimestamp }
    });
  };
  const onDateChange = value => {
    // let defaultValue = getDefaultValue(e.value);
    setSignalTranslationChange({
      SelectedSignalTranslation: { ...signalTranslationManager.SelectedSignalTranslation, SignalTranslationDateTime: moment(value).unix() }
    });
  };

  const getUnitComponentTypeInfoById = id => {
    let sensorInfo = {
      SignalTranslationAcceptedErrorTolerance: '',
      OutputRangeLow: '',
      OutputRangeHigh: '',
      UnitOfMeasure: '',
      SignalTranslationApprovedSubComponentId: 0,
      SignalTranslationEquationId: 0
    };
    if (unitSubComponentDetails.length > 0 && id && id > 0) {
      const unitComponentType = unitSubComponentDetails.filter(comp => comp.ApprovedSubComponentId === parseInt(id))[0];
      sensorInfo.SignalTranslationApprovedSubComponentId = parseInt(id);
      if (unitComponentType) {
        sensorInfo.SignalTranslationAcceptedErrorTolerance = unitComponentType.SignalTranslationAcceptedErrorTolerance;
        sensorInfo.OutputRangeLow = unitComponentType.OutputRangeLow;
        sensorInfo.OutputRangeHigh = unitComponentType.OutputRangeHigh;
        sensorInfo.UnitOfMeasure = unitComponentType.UnitOfMeasure;
        sensorInfo.SignalTranslationEquationId = unitComponentType.SignalTranslationEquationId;
      }
    }

    return sensorInfo;
  };

  const submitForm = e => {
    e.preventDefault();

    if (!validateInput()) {
      return;
    }
    let saveData = signalTranslationManager.SelectedSignalTranslation;
    saveData.UnitId = parseInt(unitId);
    saveData.UnitSerialNumber = parseInt(unitSerialNumber);
    saveData.UpdatedBy = Cookies.get(`userid-${envName}`) || 0;

    // These needs to be reset in order to be finalized and updated
    saveData.IsFinalized = false;
    saveData.IsUploaded = false;
    saveData.Status = SIGNALTRANSLATION_DRAFT;

    if (!IsEdit) {
      saveData.SignalTranslationId = 0;
      saveData.GuidIdentifier = uuidv4();
      widgetCode = 'SIGNALTRANSLATION_ADD';
    }
    saveSignalTranslation(saveData, unitSerialNumber, true, widgetCode);
  };

  const validateInput = () => {
    let formErrors = {};
    let isValid = true;

    if (
      !signalTranslationManager ||
      !signalTranslationManager.SelectedSignalTranslation ||
      !signalTranslationManager.SelectedSignalTranslation.ComponentPartId ||
      isRequired(signalTranslationManager.SelectedSignalTranslation.ComponentPartId, 1)
    ) {
      formErrors.ComponentPartId = intl.formatMessage({
        id: 'signalTranslation.sensorMandatory',
        defaultMessage: 'Sensor is mandatory'
      });
      isValid = false;
    }

    if (
      !signalTranslationManager ||
      !signalTranslationManager.SelectedSignalTranslation ||
      !signalTranslationManager.SelectedSignalTranslation.SignalTranslationApprovedSubComponentId ||
      isRequired(signalTranslationManager.SelectedSignalTranslation.SignalTranslationApprovedSubComponentId, 1)
    ) {
      formErrors.SignalTranslationApprovedSubComponentId = intl.formatMessage({
        id: 'signalTranslation.componentMandatory',
        defaultMessage: 'SignalTranslation component is mandatory'
      });
      isValid = false;
    }

    if (
      !signalTranslationManager ||
      !signalTranslationManager.SelectedSignalTranslation ||
      !signalTranslationManager.SelectedSignalTranslation.SignalTranslationDateTime ||
      isRequired(signalTranslationManager.SelectedSignalTranslation.SignalTranslationDateTime, 1)
    ) {
      formErrors.SignalTranslationDateTime = intl.formatMessage({
        id: 'signalTranslation.signalTranslationDateMandatory',
        defaultMessage: 'SignalTranslation Date is mandatory'
      });
      isValid = false;
    }
    setFormErrors(formErrors);

    return isValid;
  };

  const unitSensorOption = () => {
    let unitComponentData = [];

    const sensorComponents = unitComponentParts;

    sensorComponents.forEach(element => {
      unitComponentData.push({
        ...element,
        label: element.ModelComponent,
        value: element.ComponentPartId
      });
    });
    return unitComponentData.sort(compareValues('ModelComponent'));
  };

  const unitSubComponentOption = id => {
    let unitSubComponentData = [];

    const subComponents = unitSubComponentDetails.filter(x => x.ComponentPartId == id);

    subComponents.forEach(element => {
      unitSubComponentData.push({
        ...element,
        label: element.ModelComponent,
        value: element.ApprovedSubComponentId
      });
    });
    return unitSubComponentData.sort(compareValues('ModelComponent'));
  };

  const disablePastDates = current =>
    current.isAfter(
      moment()
        .tz(currentTimezone)
        .subtract(1, 'day')
    );

  let ddlClass = localformErrors && localformErrors.ComponentPartId ? s.ddlError : '';
  const returnUrl = IsEdit
    ? `/unit/signal-translations/${unitSerialNumber}/view/${unitId}/${signalTranslationId}`
    : '/unit/signal-translations/' + unitSerialNumber;
  let messageId = (signalTranslationManager && signalTranslationManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  return (
    <div className={s.signalTranslation}>
      {signalTranslationManager.isLoading && <LoadingSpinner />}
      {signalTranslationManager.isOpSuccessful && !signalTranslationManager.showBanner ? <Navigate to={returnUrl} /> : ''}
      {IsRedirect ? <Navigate to={returnUrl} /> : ''}
      <Banner
        key={uuid()}
        failureText={messageText}
        showBanner={signalTranslationManager.showBanner || false}
        status={signalTranslationManager.isOpSuccessful}
        successText={messageText}
      />
      <ContentTemplate selectedPage="signalTranslation" userProfileWidgets={userProfileWidgets} widgetCode={widgetCode} tagoutRequired={false}>
        <div className={s.contentWrapper}>
          <div className={s.signalTranslationHeader}>
            <GoBack className={s.backLink}>
              &lt; &nbsp;
              <FormattedMessage id="signalTranslation.backToSignalTranslations" defaultMessage="BACK" />
            </GoBack>
            <h3 data-unittest="headingLabel">
              <FormattedMessage id="signalTranslation.signalTranslation" defaultMessage="SignalTranslation" />
            </h3>
          </div>
          <div className={s.signalTranslationContent}>
            <Row className={s.breakrow}>
              <Col sm={12}>
                <h4>
                  <FormattedMessage id="signalTranslation.details" defaultMessage="Details" />
                </h4>
              </Col>
            </Row>
            <Row className={s.breakrow}>
              <Col sm={2}>
                <Form.Label>
                  <FormattedMessage id="signalTranslation.unit" defaultMessage="Unit" />
                </Form.Label>
              </Col>
              <Col sm={10}>{unitSerialNumber}</Col>
            </Row>
            <Row className={s.breakrow}>
              <Col sm={2}>
                <Form.Label>
                  <FormattedMessage id="signalTranslation.reporter" defaultMessage="Reporter" />
                </Form.Label>
              </Col>
              <Col sm={10}>{userName}</Col>
            </Row>

            <hr className={s.breakhr} />

            <Row className={s.breakrow}>
              <Col sm={3}>
                <Form.Group controlId="frmSensorId">
                  <Form.Label>
                    <FormattedMessage id="signalTranslation.sensor" defaultMessage="Sensor" />
                  </Form.Label>
                  {!IsEdit ? (
                    <Dropdown
                      id="drpSensorId"
                      dataArray={unitSensorOption()}
                      controlData={{
                        placeholderText: <FormattedMessage id="signalTranslation.selectSensor" defaultMessage="Select Sensor" />,
                        customClassName: ddlClass
                      }}
                      onDropdownChange={onSensorDropdownChange}
                      selectedOption={unitSensorOption().filter(
                        option => option.value === signalTranslationManager.SelectedSignalTranslation.ComponentPartId
                      )}
                      disabled={IsEdit}
                      data-unittest="formSetpoint"
                    />
                  ) : (
                    <div className={s.paddingTop}>
                      <Form.Label>{signalTranslationManager.SelectedSignalTranslation.ComponentPartName}</Form.Label>
                    </div>
                  )}
                  {localformErrors && localformErrors.ComponentPartId && (
                    <p role="alert" className={s.error}>
                      {localformErrors.ComponentPartId}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col sm={3}>
                <Form.Group controlId="frmSensorId">
                  <Form.Label>
                    <FormattedMessage id="signalTranslation.signalTranslationComponent" defaultMessage="SignalTranslation Component" />
                  </Form.Label>
                  {!IsEdit ? (
                    <Dropdown
                      id="drpSubComponentId"
                      dataArray={unitSubComponentOption(signalTranslationManager.SelectedSignalTranslation.ComponentPartId)}
                      controlData={{
                        placeholderText: (
                          <FormattedMessage id="signalTranslation.signalTranslationComponent" defaultMessage="Select SignalTranslation Component" />
                        ),
                        customClassName: ddlClass
                      }}
                      onDropdownChange={onDropdownChange}
                      selectedOption={unitSubComponentOption(signalTranslationManager.SelectedSignalTranslation.ComponentPartId).filter(
                        option => option.value === signalTranslationManager.SelectedSignalTranslation.SignalTranslationApprovedSubComponentId
                      )}
                      disabled={IsEdit}
                    />
                  ) : (
                    <div className={s.paddingTop}>
                      <Form.Label>
                        {signalTranslationManager.SelectedSignalTranslation.ComponentPartName +
                          '_' +
                          signalTranslationManager.SelectedSignalTranslation.SignalTranslationComponentName}
                      </Form.Label>
                    </div>
                  )}
                  {localformErrors && localformErrors.SignalTranslationApprovedSubComponentId && (
                    <p role="alert" className={s.error}>
                      {localformErrors.SignalTranslationApprovedSubComponentId}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col sm={3}>
                <Form.Group controlId="frmSignalTranslationDatetime">
                  <Form.Label>
                    <FormattedMessage id="signalTranslation.signalTranslationDatetime" defaultMessage="SignalTranslation Date Time" />
                  </Form.Label>
                  <DateTime
                    isValidDate={disablePastDates}
                    onChange={m => onDateChange(m.valueOf())}
                    timeFormat="HH:mm"
                    dateFormat="DD-MMM-YYYY"
                    value={moment.unix(currentTimestamp).tz(currentTimezone)}
                    defaultValue={moment(currentTimestamp).tz(currentTimezone)}
                    closeOnSelect
                  />
                  {localformErrors && localformErrors.SignalTranslationDateTime && (
                    <p role="alert" className={s.error}>
                      {localformErrors.SignalTranslationDateTime}
                    </p>
                  )}
                </Form.Group>
              </Col>
              <Col sm={6}></Col>
            </Row>
            <Row className={s.breakrow}>
              <Col sm={2}>
                <Form.Label>
                  <FormattedMessage id="signalTranslation.tolerance" defaultMessage="Tolerance" />
                </Form.Label>
              </Col>
              <Col sm={10}>{signalTranslationManager.SelectedSignalTranslation.SignalTranslationAcceptedErrorTolerance}</Col>
            </Row>
            <Row className={s.breakrow}>
              <Col sm={2}>
                <Form.Label>
                  <FormattedMessage id="signalTranslation.sensorRange" defaultMessage="Sensor Range" />
                </Form.Label>
              </Col>
              <Col sm={10}>
                <Row>
                  <Col md={2}>
                    <Form.Label>
                      <FormattedMessage id="signalTranslation.low" defaultMessage="Low" />
                    </Form.Label>{' '}
                    : {signalTranslationManager.SelectedSignalTranslation.OutputRangeLow}
                  </Col>
                  <Col md={2}>
                    <Form.Label>
                      <FormattedMessage id="signalTranslation.high" defaultMessage="High" />
                    </Form.Label>{' '}
                    : {signalTranslationManager.SelectedSignalTranslation.OutputRangeHigh}
                  </Col>
                  <Col md={2}>
                    <Form.Label>
                      {' '}
                      <FormattedMessage id="signalTranslation.unitOfMeasure" defaultMessage="Unit Of Measure" />
                    </Form.Label>{' '}
                    : {signalTranslationManager.SelectedSignalTranslation.UnitOfMeasure}
                  </Col>
                  <Col md={6}></Col>
                </Row>
              </Col>
            </Row>
          </div>
        </div>
        <SignalTranslationResults
          UpdateAllowed={isUpdateAllowed}
          signalTranslationManager={signalTranslationManager}
          setSignalTranslationResults={setSignalTranslationResultChange}
          intl={intl}
        />
        <SignalTranslationConstants
          UpdateAllowed={isUpdateAllowed}
          signalTranslationManager={signalTranslationManager}
          setSignalTranslationRequired={signalTranslationRequiredToggleHandler}
          setSignalTranslationConstant={setSignalTranslationConstant}
          intl={intl}
        />
        {IsEdit && isCommentAllowed && (
          <SignalTranslationComments
            UpdateAllowed={isUpdateAllowed}
            signalTranslationManager={signalTranslationManager}
            intl={intl}
            currentTimezone={currentTimezone}
            saveSignalTranslationComment={saveSignalTranslationComment}
            unitSerialNumber={unitSerialNumber}
          />
        )}
        <Row className={s.breakRow}>
          <Col sm={12}>
            <Button
              variant="outline-secondary"
              className={classNames(s.btnSaveChanges)}
              onClick={submitForm}
              noValidate
              data-unittest="saveData"
            >
              <FormattedMessage id="signalTranslation.save" defaultMessage="SAVE CHANGES" />
            </Button>
            <Link to={returnUrl}>
              <Button variant="outline-secondary" className={s.btnCancel}>
                <FormattedMessage id="signalTranslation.cancel" defaultMessage="CANCEL" />
              </Button>
            </Link>
          </Col>
        </Row>
      </ContentTemplate>
    </div>
  );
};

SignalTranslation.propTypes = {
  describeSignalTranslation: PropTypes.func.isRequired,
  describeSignalTranslationEquation: PropTypes.func.isRequired,
  getUnitComponentParts: PropTypes.func.isRequired
};

export default injectIntl(SignalTranslation);
